export default "__VITE_ASSET__i89dbj26__"